import React from 'react';
import { Book, Check } from 'lucide-react';
const modules = [{
  title: 'Tomo 1 – Tu Vehículo sin Misterios',
  desc: 'Entendé cómo funciona tu auto sin tecnicismos. Perdé el miedo y aprendé qué es realmente importante.',
  color: 'bg-blue-50 border-blue-200'
}, {
  title: 'Tomo 2 – Revisiones Básicas que Vos Sí Podés Hacer',
  desc: 'Controles simples que previenen fallas graves. Detectá problemas antes de que sea tarde.',
  color: 'bg-green-50 border-green-200'
}, {
  title: 'Tomo 3 – El Mantenimiento Preventivo que Realmente Importa',
  desc: 'Qué cambiar, cuándo hacerlo y cómo no gastar de más. Evitá mantenimientos innecesarios.',
  color: 'bg-yellow-50 border-yellow-200'
}, {
  title: 'Tomo 4 – Cómo NO Ser Estafado por un Mecánico',
  desc: 'Qué preguntar, qué exigir y qué no aceptar. Entrá al taller con seguridad y criterio.',
  color: 'bg-red-50 border-red-200'
}, {
  title: 'Tomo 5 – Fallas Comunes y Qué Hacer Antes de que Sea Tarde',
  desc: 'Identificá síntomas, ruidos y señales de alerta. Actuá con calma y conocimiento.',
  color: 'bg-purple-50 border-purple-200'
}, {
  title: 'Tomo 6 – Plan Maestro de Cuidado del Vehículo',
  desc: 'Un sistema anual completo. Control total de mantenimiento, hábitos y gastos. Todo organizado.',
  color: 'bg-indigo-50 border-indigo-200'
}];
export function ModulesSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-59">
      <div className="max-w-5xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-62">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-63">
            6 Tomos cargados de valor práctico
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
          {modules.map((module, idx) => <div key={idx} className={`p-6 rounded-xl border-2 ${module.color} shadow-sm hover:shadow-md transition-all`} data-id="element-65">
              <div className="flex items-start gap-4" data-id="element-66">
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-67">
                  <Book className="w-8 h-8 text-gray-800" data-id="element-68" />
                </div>
                <div data-id="element-69">
                  <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-70">
                    {module.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-71">{module.desc}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}